{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/OHAT",
	"name": "OHAT",
	"language": "fr-BE",
	"title": "Echelle de OHAT",
	"status": "active",
	"publisher": "Corilus NV",
	"description": "Le score 0 signifie \"en bonne santé\", le score 2 \"en mauvais état\". En cas de présence d’une cote 1 ou 2 à n’importe quel item il faut immédiatement référer le patient à un dentiste. Une addition des scores permet d’avoir une valeur entre 0 et 16. Plus le score est élevé, plus l’état de santé de la bouche est mauvais.",
	"purpose": "Évaluation de la santé bucco-dentaire",
	"item": [
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "60200",
			"text": "Lèvres",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "60201",
						"display": "Roses, humides, lisses"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "60202",
						"display": "Sèche, gercée, rougeur angulaire"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "60203",
						"display": "Morsure, gonflée, ulcération, saignement angulaire"
					}
				}
			]
		},
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "60300",
			"text": "Langue",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "60301",
						"display": "Roses, humides, normale, rose"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "60302",
						"display": "Rouge, fissurée et brillante sans enflure. Sèche. Plaques sur une partie de sa surface. Petit ulcère visible"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "60303",
						"display": "Enflure. Plaques rouges ou blanches sur la majorité de sa surface. Gros ulcère visible"
					}
				}
			]
		},
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "60400",
			"text": "Gencives et muqueuses",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "60401",
						"display": "Roses, humides, lisses, aucun saignement"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "60402",
						"display": "Sèche, brillante, rugueuse, gonflée, blessure ou ulcère sous prothèse"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "60403",
						"display": "Gonflée, saignement, ulcérations, zones rouges ou blanches, erythème sous prothèse"
					}
				}
			]
		},
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "60500",
			"text": "Salive",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "60501",
						"display": "Tissus humide, abondante, aqueuse et fluide"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "60502",
						"display": "Peu de salive,collante, sensation de bouche sèche, exprimée par le résident"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "60503",
						"display": "Muqueuse parcheminée et rouge, peu ou pas de salive, salive épaisse, sensation de bouche sèche exprimée par le patient"
					}
				}
			]
		},
		{
			"type": "group",
			"linkId": "60599",
			"text": "Dents naturelles",
			"item": [
				{
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"linkId": "60600",
					"text": "Le résident a-t-il encore certaines de ses dents naturelles?",
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "60601",
								"display": "Oui"
							}
						},
						{
							"valueCoding": {
								"code": "60602",
								"display": "Non"
							}
						}
					]
				},
				{
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"linkId": "60700",
					"text": "Dents naturelles",
					"required": true,
					"enableWhen": [
						{
							"question": "60600",
							"operator": "=",
							"answerCoding": {
								"code": "60601"
							}
						}
					],
					"answerOption": [
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							],
							"valueCoding": {
								"code": "60701",
								"display": "Absence de carie évidente, absence de racine dentaire, absence de dent cassée, absence de mobilité dentaire"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							],
							"valueCoding": {
								"code": "60702",
								"display": "1 à 3 dents cariées, racines ou dent cassées, usées ou abrasées"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							],
							"valueCoding": {
								"code": "60703",
								"display": "Plus de 4 dents cariées, racines ou dent cassées, usées ou abrasées, moins de 4 dents présentes, dent très mobile"
							}
						}
					]
				}
			]
		},
		{
			"type": "group",
			"linkId": "60799",
			"text": "Prothèses dentaires",
			"item": [
				{
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"linkId": "60800",
					"text": "Le résident a-t-il une prothèse dentaire (partielle ou complète)?",
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "60801",
								"display": "Oui"
							}
						},
						{
							"valueCoding": {
								"code": "60802",
								"display": "Non"
							}
						}
					]
				},
				{
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"linkId": "60900",
					"text": "Prothèses dentaires",
					"required": true,
					"enableWhen": [
						{
							"question": "60800",
							"operator": "=",
							"answerCoding": {
								"code": "60801"
							}
						}
					],
					"answerOption": [
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							],
							"valueCoding": {
								"code": "60901",
								"display": "Prothèse adaptée, Prothèse portée, Bonne rétention et stabilité"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							],
							"valueCoding": {
								"code": "60902",
								"display": "Prothèse partiellement inadaptée. Fracture légère de la prothèse. Perte ou fracture d’une dent. Mauvaise rétention ou stabilité avec ou sans lésions aux muqueuse, gencives et palais. Prothèse portée 1 à 2 heures par jour"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							],
							"valueCoding": {
								"code": "60903",
								"display": "Prothèse inadaptée. Fracture importante de la prothèse. Perte ou fracture de plusieurs dents. Ne porte pas la prothèse ou perte. Port de la prothèse uniquement avec l’utilisation d’un adhésif"
							}
						}
					]
				}
			]
		},
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "61000",
			"text": "Hygiène buccale",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "61001",
						"display": "Propre, aucun dépôt, absence de tartre sur les dents et/ou les prothèses, bonne haleine"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "61002",
						"display": "Présence localisée de débris d’aliments ou de tartre sur les dents ou les prothèses. Mauvaise haleine perceptible lors de longues interactions"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "61003",
						"display": "Présence généralisée de débris, d’aliments ou de tartre sur les dents ou les prothèses, Halitose (très mauvaise haleine)"
					}
				}
			]
		},
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "61100",
			"text": "Douleur buccale",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "61101",
						"display": "Aucun signe de douleur buccale (physique, verbal ou comportemental)"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "61102",
						"display": "Signe occasionnels de douleur buccale (physiques, verbaux ou comportementaux)"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "61103",
						"display": "Signes fréquents de douleur buccale (physiques, verbaux ou comportementaux)"
					}
				}
			]
		}
	]
}
